import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import MyBranchState from "../Data/ADIMyBranchState";

const initialState: MyBranchState = {
    warehouseId: "",
    warehouseCode: "",
    warehouseDisplayName: "",
    warehouseNameSection: "",
};

const reducer = {
    "Custom/MyBranch/PopulateConfigParam": (draft: Draft<MyBranchState>) => {},
    "Custom/MyBranch/CleanConfig": (draft: Draft<MyBranchState>) => {
        draft.warehouseId = "";
        draft.warehouseCode = "";
        draft.warehouseDisplayName = "";
        draft.warehouseNameSection = "";
    },

    "Custom/MyBranch/SetConfig": (
        draft: Draft<MyBranchState>,
        action: { result: MyBranchState },
    ) => {
        draft.warehouseId = action.result.warehouseId || "";
        draft.warehouseCode = action.result.warehouseCode || "";
        draft.warehouseDisplayName = action.result.warehouseDisplayName || "";
        draft.warehouseNameSection = action.result.warehouseNameSection || "";
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
